module.exports = __webpack_public_path__ + "h5/img/master_10.0b5cadc4.jpg";